import moment from 'moment-timezone';

export const formatEntriesToText = (entries) => {
  let storyText = "";

  // Sort entries by date first
  entries.sort((a, b) => new Date(a.createdAt.seconds * 1000) - new Date(b.createdAt.seconds * 1000));

  let lastKnownTimeZone = moment.tz.guess(); // Default to client's timezone initially
  const japanTimeZone = "Asia/Tokyo";

  entries.forEach(entry => {
    const entryDate = entry.createdAt && entry.createdAt.seconds
      ? moment(entry.createdAt.seconds * 1000).format('MMMM Do YYYY')
      : 'Unknown Date';

    storyText += `----------------------------------------\n`;
    storyText += `Date: ${entryDate}\n`;
    storyText += `----------------------------------------\n\n`;

    if (entry.title) {
      storyText += `Title: ${entry.title}\n\n`;
    }

    if (entry.content) {
      storyText += `Entry:\n${entry.content}\n\n`;
    }

    if (entry.photos && entry.photos.length > 0) {
      storyText += `Places:\n`;
      entry.photos.forEach((photo, index) => {
        if (!photo.place) return; // Skip if no place data
        storyText += `  Place ${index + 1}:\n`;
        if (photo.date_taken) {
          let dateToFormat;
          // Check if it's a Firebase Timestamp object (has seconds property)
          if (photo.date_taken.seconds && typeof photo.date_taken.seconds === 'number') {
            dateToFormat = new Date(photo.date_taken.seconds * 1000); // Convert seconds to milliseconds
          } else {
            // Otherwise, assume it might be an ISO string or already a Date object
            dateToFormat = photo.date_taken;
          }

          let currentTimeZone = lastKnownTimeZone; // Start with the last known
          if (photo.place && photo.place.address) {
            if (photo.place.address.toLowerCase().includes('japan')) {
              currentTimeZone = japanTimeZone;
              lastKnownTimeZone = japanTimeZone; // Update last known
            }
            // Add more rules here if needed
            else {
              // If address exists but doesn't match known rules, keep using the last known one
              currentTimeZone = lastKnownTimeZone;
            }
          }
          const momentDate = moment(dateToFormat);

          if (momentDate.isValid()) {
            let formattedTime;
            try {
               formattedTime = momentDate.tz(currentTimeZone).format('h:mm A z');
            } catch (tzError) {
               console.warn(`Invalid timezone detected ('${currentTimeZone}'). Falling back to client default. Error: ${tzError}`);
               formattedTime = momentDate.tz(moment.tz.guess()).format('h:mm A z');
            }
            storyText += `    Time: ${formattedTime}\n`;
          } else {
             console.warn("Skipping invalid photo date_taken:", photo.date_taken);
          }
        }

        if (photo.place.name) {
          storyText += `    Name: ${photo.place.name}\n`;
        }
        if (photo.place.address) {
          storyText += `    Address: ${photo.place.address}\n`;
        }
        if (photo.place.types && photo.place.types.length > 0) {
          storyText += `    Types: ${photo.place.types.join(', ')}\n`;
        }
        
        if (photo.caption) {
          storyText += `    AI Caption: ${photo.caption}\n`;
        }
         if (photo.story_caption) {
          let scoreLabel = "";
          const score = photo.story_caption_score;
          if (score >= 95) scoreLabel = "Iconic";
          else if (score >= 85) scoreLabel = "Excellent";
          else if (score >= 70) scoreLabel = "Very Good";
          else if (score >= 50) scoreLabel = "Good";
          else if (score >= 30) scoreLabel = "Fair";
          else scoreLabel = "Basic";
          
          storyText += `    Story Caption: ${photo.story_caption} (Score: ${score}/100 - ${scoreLabel})\n`;
        }
        storyText += `\n`; // a newline after each photo's details
      });
    }
    storyText += `\n\n`; // extra space between entries
  });

  return storyText;
};
